import { render, staticRenderFns } from "./personalMeasurements.vue?vue&type=template&id=9f319102&"
import script from "./personalMeasurements.vue?vue&type=script&lang=js&"
export * from "./personalMeasurements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports